import { render } from "./AboutJum.vue?vue&type=template&id=05240abe&scoped=true"
import script from "./AboutJum.vue?vue&type=script&lang=js"
export * from "./AboutJum.vue?vue&type=script&lang=js"

import "./AboutJum.vue?vue&type=style&index=0&id=05240abe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05240abe"]])

export default __exports__